import { useEffect, useState } from "react";

export function GridOverlay() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onKeyDown = (e: KeyboardEvent) => {
      if (e.ctrlKey && !e.metaKey && !e.altKey && !e.shiftKey && (e.key === "l" || e.key === "L")) {
        e.preventDefault();
        setShow((v) => !v);
      }
    };
    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, []);

  return (
    <>
      <button
        type="button"
        className="grid-toggle"
        onClick={() => setShow((v) => !v)}
        aria-pressed={show}
        aria-label="Toggle layout grid"
        title="Toggle layout grid"
        style={{ display: "none" }}
      >
        <span className="grid-toggle-dot" aria-hidden="true" />
        Grid
      </button>

      {show && (
        <div className="grid-overlay" aria-hidden="true">
          <div className="grid-overlay-inner">
            {Array.from({ length: 12 }).map((_, i) => (
              <div key={i} className="grid-overlay-col">
                <span className="grid-overlay-num">{i + 1}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </>
  );
}
